

























































































import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import FormCode from "@/common/components/organisms/FormCode.vue";
import FormLabel from "@/common/components/organisms/FormLabel.vue";

import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Vue, Component } from "vue-property-decorator";

import commons from "@/common/store/modules/commons";
import LocalStorage from "@/general/utils/storage";

//API call
import {
  myPageEmailResetVerification,
  myPageEmailResetUUIDVerification
} from "@/general/store/api";
import AuthStorage from "@/general/utils/auth";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});

@Component({
  components: {
    TheTemplateM,
    InputText,
    ButtonMain,
    FormCode,
    FormLabel,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  }
})
export default class MyPageIdentityVerification extends Vue {
  $refs!: {
    form: HTMLFormElement;
    codeValidationProvider: HTMLFormElement;
  };

  step = 3;
  stepOptions: any = [
    { step: 1, label: "入力" },
    { step: 2, label: "メール確認" },
    { step: 3, label: "本人認証" },
    { step: 4, label: "完了" }
  ];

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "メールアドレス変更",
      url: "",
      pageType: "lower"
    }
  ];

  id = "";
  code = "";
  uuid = "";

  wrongMatch = false;

  get userInfo() {
    try {
      return JSON.parse(String(LocalStorage.getItem("userDetails")));
    } catch (_) {
      location.href = "/system-error/";
    }
    return null;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    commons.getBreadcrumb(this.breadcrumb);

    // User logged in??
    if (!LocalStorage.getItem("AccessToken")) {
      location.href = "/system-error/";
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.has("uuid")) {
      this.uuid = urlParams.get("uuid") as string;
    }

    await myPageEmailResetUUIDVerification({
      uuid: this.uuid
    }).catch((error: any) => {
      const { response, request } = error;

      if (request.responseURL.endsWith("/api/email_reset/verification_uuid/")) {
        if (response.status === 404) {
          if (response?.data?.detail === "Not found.") {
            window.location.href = "/my-page/email-settings-expired/";
          }
        } else if (response.status === 400) {
          const message =
            response.data && response.data.length > 0 ? response.data[0] : "";
          if (message === "You have reached the maximum attempt limit.") {
            window.location.href = "/my-page/email-settings-failed/";
          } else if (message === "Email is already changed.") {
            window.location.href = "/my-page/email-settings-completed/";
          } else if (message === "URL is already expired.") {
            window.location.href = "/my-page/email-settings-expired/";
          }
        }
      }
    });
  }

  async submit() {
    this.wrongMatch = false;
    const emailReset: any = await myPageEmailResetVerification({
      user: this.userInfo?.id,
      email: this.id,
      auth_code: this.code,
      uuid: this.uuid
    }).catch((error: any) => {
      this.wrongMatch = true;

      const { response, request } = error;

      if (request.responseURL.endsWith("/api/email_reset/verification/")) {
        if (response.status === 400) {
          const message =
            response.data && response.data.length > 0 ? response.data[0] : "";
          if (message === "You have reached the maximum attempt limit.") {
            window.location.href = "/my-page/email-settings-failed/";
          } else if (message === "Email is already changed.") {
            window.location.href = "/my-page/email-settings-completed/";
          } else if (message === "URL is already expired.") {
            window.location.href = "/my-page/email-settings-expired/";
          }
        }
      }

      return;
    });

    if (emailReset) {
      window.location.href = "/my-page/email-settings-done/";
    }
  }

  setCode(code: any) {
    this.code = code;
    this.$nextTick(function() {
      this.$refs.codeValidationProvider.validate();
    });
  }
}
